import { Apis } from "../../lib/Apis";
import Swal from "sweetalert2";

const useUsers = () => {
  const getAdminDetails = async (setUserData) => {
    try {
      const response = await Apis.getUser();
      setUserData(response.data.getUser);
      return response.data;
    } catch (error) {
      // 401 errors are now handled globally by the interceptor
      console.error("Error fetching admin details:", error);
    }
  };

  return { getAdminDetails };
};

export default useUsers;
